import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Textarea = React.forwardRef(function Textarea({ className, style, rows = 4, ...rest }, ref) {
    return (_jsx("textarea", { ref: ref, rows: rows, className: className, "data-textarea": true, style: {
            display: 'block',
            width: '100%',
            padding: `var(--space-2) var(--space-3)`,
            borderRadius: 'var(--radius-input)',
            border: '1px solid var(--text-dim)',
            background: 'var(--surface)',
            color: 'var(--text)',
            fontFamily: 'var(--font-ui)',
            fontSize: 'max(16px, var(--font-size-2xs))',
            lineHeight: 'var(--line-height-body)',
            resize: 'vertical',
            outlineColor: 'var(--focus-ring)',
            ...style,
        }, ...rest }));
});
//# sourceMappingURL=Textarea.js.map